<button type="button" color="primary" mat-icon-button (click)="openInfoDialog()" matTooltip="Zoom">
  <mat-icon>loupe</mat-icon>
</button>
